import React, { memo, useCallback } from 'react';
import { FlatList, View } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { Space } from '@redlink/components/atoms';
import { PreviewCategoryItem } from '@redlink/components/molecules';
import { useLocale } from '@redlink/assets/locale';

export const PreviewCategoryList = memo(
  ({
    renderItem: renderItemOrigin,
    horizontal,
    showsHorizontalScrollIndicator,
    ItemSeparatorComponent,
    selectedIndex = 0,
    onChange,
    style,
    data,
    ...rest
  }) => {
    const { styles } = useStyle();
    const { dictionary } = useLocale();
    data = [{ id: null, title: dictionary.all }, ...data];
    const renderItem = useCallback(
      ({ item, index }) => {
        const isFocused = selectedIndex === index;
        return (
          <PreviewCategoryItem
            {...{ item, isFocused }}
            onPress={() => onChange && onChange(item, index)}
          />
        );
      },
      [selectedIndex, onChange]
    );
    return (
      <View {...{ style }}>
        <FlatList
          extraData={selectedIndex}
          showsHorizontalScrollIndicator={false}
          horizontal
          ItemSeparatorComponent={() => <Space />}
          {...{ renderItem, data }}
          {...rest}
        />
      </View>
    );
  }
);

const useStyle = createUseStyle(({ colors, shadow, size }) => ({}));
